import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'byKey'
})
export class ByKeyPipe implements PipeTransform {

    transform<T>(value: T[], key: string, field?: string): T {
        return value?.find(p => p[field || 'key'] === key);
    }

}
